import { MaturityOption } from '@moment/horizon-data-access/proposal'

/**
 * Get the display label for a maturity option
 */
export const getMaturityOptionLabel = (
  maturityOption: MaturityOption | null | undefined,
  useCallAdjustedMaturity?: boolean,
): string => {
  if (maturityOption === MaturityOption.next_call_date) {
    return 'Next call date'
  }
  if (
    maturityOption === MaturityOption.workout_date ||
    useCallAdjustedMaturity === true
  ) {
    return 'Call-adjusted maturity'
  }
  return 'Maturity date'
}
